<button
  mat-mini-fab
  class="mat-mini-fab-map-control"
  [matTooltip]="'map.export_dxf.tooltip' | translate"
  matTooltipPosition="left"
  matTooltipShowDelay="500"
  (click)="openDXF()"
>
  <mat-icon>draw_abstract</mat-icon>
</button>
